import { render } from "./PersonalInfoBasicTransactions.vue?vue&type=template&id=3efd2c10&scoped=true"
import script from "./PersonalInfoBasicTransactions.vue?vue&type=script&lang=js"
export * from "./PersonalInfoBasicTransactions.vue?vue&type=script&lang=js"

import "./PersonalInfoBasicTransactions.vue?vue&type=style&index=0&id=3efd2c10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efd2c10"]])

export default __exports__